// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13WI9","importantInfo":"styles_importantInfo__3dTsI"};